// Framework control references on an onGuard check (CIS Microsoft 365, NIST SP 800-53), as the Security page shows them.
// Moved from lib/security-export.js when the string-built exporter was retired for the Security posture report
// (ENTRAID-347 redesign, implementation plan C2b).

export const REF_FRAMEWORK_NAMES = Object.freeze({ 'cis-m365': 'CIS Microsoft 365', 'nist-800-53': 'NIST SP 800-53' });
export const REF_FRAMEWORK_SHORT = Object.freeze({ 'cis-m365': 'CIS', 'nist-800-53': 'NIST' });

/** The well-formed references of a list (each has a string controlId); anything else is dropped. */
export const refList = (v) => (Array.isArray(v) ? v.filter((r) => r && typeof r.controlId === 'string') : []);

/** "CIS 1.1.1": the short framework name and the control id. */
export const refLabel = (r) => `${REF_FRAMEWORK_SHORT[r.framework] ?? r.framework} ${r.controlId}`;
